module.exports = __webpack_public_path__ + "img/ubuntu.c0d133b1.svg";